import React, { useEffect, useState } from 'react';
import './TeaserSection.css';
import API_BASE_URL from './config';

const TeaserSection = () => {
  const [deals, setDeals] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/deals`)
      .then(res => res.json())
      .then(data => setDeals(data))
      .catch(err => console.error('Failed to fetch deals:', err));
  }, []);

  return (
    <div className="teaser-section">
      {/* Video Teaser */}
      <div className="video-container">
        <video
          src="/sample-discount-video.mp4"
          autoPlay
          muted
          loop
          playsInline
          style={{
            width: '100%',
            height: 'auto',
            borderRadius: '12px',
            display: 'block'
          }}
        />
      </div>

      <div className="brand-mentions">
        <h2>Exclusive Deals From Top Brands</h2>
        <div className="brand-cards">
          {deals.slice(0, 5).map((deal) => (
            <div key={deal._id} className="brand-card">
              <img
                src={`/uploads/${deal.image}`}
                alt={deal.merchantName}
              />
              <div className="brand-info">
                <h4>{deal.merchantName}</h4>
                <p>{deal.discountValue} off</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Final Hook */}
      <div className="hook">
        <h3>Want to know how much you can save today?</h3>
        <a href="/deals" className="hook-button">Browse All Deals</a>
      </div>
    </div>
  );
};

export default TeaserSection;
